import Route from '@ember/routing/route';
import { useQuery } from 'glimmer-apollo';
import { GAMES_LIST_QUERY } from 'embroil/gql/queries/games-list';

export default class GamesIndexRoute extends Route {
  query = useQuery(this, () => [GAMES_LIST_QUERY]);

  async model() {
    try {
      await this.query.promise;
      return {
        games: this.query.data?.games || [],
        loading: this.query.loading,
        error: this.query.error
      };
    } catch (error) {
      console.error('Error loading games:', error);
      return {
        games: [],
        loading: false,
        error: error
      };
    }
  }
}
